import style from "./droplead_form.module.css";
import { Formik, Form } from "formik";
import InputText from "@/components/UI/input/input_text";
import { customerDropleadInfoSchema } from "@/helpers/schema_validation";
import { useState } from "react";

function Field({
  fieldName,
  fieldTitle,
  fieldPlaceHolder,
  onChange: handleChange,
  onBlur: handleBlur,
  values,
  errors,
  touched,
  parentClass,
  theme,
  maxlength="none",
  type = "text",
}) {
  const [name, setName] = useState(fieldName);
  return (
    <div className={`${parentClass}`}>
      <InputText
        type={type}
        name={name}
        title={fieldTitle}
        placeholder={fieldPlaceHolder}
        onChange={handleChange}
        onBlur={handleBlur}
        maxlength={maxlength}
        initValue={values[name]}
        errorMsg={errors[name] && touched[name] ? errors[name] : ""}
        theme={theme}
      />
    </div>
  );
}
export default function DropLeadForm({
  theme = "blue",
  onSubmit: onSubmitHandler,
  parentClass,
  children,
}) {
  const initialValues = {
    firstName: "",
    lastName: "",
    phone: "",
    consent: true,
  };

  // Initialise value from saved data
  // const customerCtx = useContext(CustomerContext);
  // useEffect(async () => {
  //   const data = await customerCtx.getCustomerInfo("droplead");
  //   if (Object.keys(data).length > 0) setReinitialise(true);
  //   setInitialValues(data);
  // }, []);
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={customerDropleadInfoSchema()}
      onSubmit={onSubmitHandler}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        setFieldValue,
        setFieldTouched,
      }) => (
        <Form
          className={parentClass}
        >
          {children &&
            children(
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
              Field,
              setFieldValue,
              setFieldTouched
            )}
        </Form>
      )}
    </Formik>
  );
}
